import styled from "styled-components";

const Background = styled.div`
  background-color: #7eb3df;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default Background;
